import React from "react";
import { Autocomplete } from "@react-google-maps/api";

type SearchResult = google.maps.places.Autocomplete | undefined;

interface Props {
  children: React.ReactNode & React.ReactChild;
  searchResult: SearchResult;
  setSearchResult: React.Dispatch<React.SetStateAction<SearchResult>>;
  onPlaceSelect: (searchResult: google.maps.places.Autocomplete) => void;
}

const GoogleSearchAutocomplete: React.FC<Props> = ({ children, searchResult, setSearchResult, onPlaceSelect }) => {
  function onLoadAutocomplete(autocomplete: SearchResult) {
    setSearchResult(autocomplete);
  }

  function placeChangeHandler() {
    if (searchResult) {
      onPlaceSelect(searchResult);
    }
  }

  if (!children) {
    return null;
  }

  return (
    <Autocomplete onPlaceChanged={placeChangeHandler} onLoad={onLoadAutocomplete}>
      {children /*input element will be wrapped here */}
    </Autocomplete>
  );
};

export default GoogleSearchAutocomplete;
